import React, { useEffect, useState, useCallback, useMemo, useRef } from 'react'

import { 
	Box,
	Alert,
	AlertTitle,
	Chip,
	Dialog,
	DialogTitle,
	DialogContent,
	TextField,
	DialogActions,
	Button,
	Divider,
	Select,
	MenuItem,
	FormControl,
	InputLabel,
	Tooltip,
	IconButton,
	Tabs,
	Tab,
} from '@mui/material'

import LoadingButton from '@mui/lab/LoadingButton';

import { ConnectButton } from "360dialog-connect-button";

import AddIcon from '@mui/icons-material/Add';
import HelpIcon from '@mui/icons-material/Help';

import useNotification from "../../Notification";
import Loading from '../../Loading';
import api from '../../../api';
import CircleIcon from '@mui/icons-material/Circle';

import ConfirmationDialog from "../../Dialogs/Confirmation"
import UsageComponent from "../Usage";

import { FacebookPlugin } from '../Instagram/index.js';

import { getSession } from '../../../auth.js';

import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import BadgeIcon from '@mui/icons-material/Badge';
import { ExibitionNameModal, EnterpriseDataModal, EnterpriseMoreModal } from './edit.js';
import InfoIcon from '@mui/icons-material/Info';
import './styles.css'

const translate =  {
	PENDING      : 'Pendente'               ,
	DELETED      : 'Deletado'               ,
	MIGRATED     : 'Migrado'                ,
	BANNED       : 'Banido'                 ,
	RESTRICTED   : 'Restrito'               ,
	RATE_LIMITED : 'Limitado (RATE_LIMITED)',
	FLAGGED      : 'Marcado (FLAGGED)'      ,
	CONNECTED    : 'Conectado'              ,
	DISCONNECTED : 'Desconectado'           ,
	UNKNOWN      : 'Desconhecido'           ,
	UNVERIFIED   : 'Não verificado'
}

const WhatsAppCallingDialog = ({ open, setOpen, submit }) => {
	const [sipUrl, setSipUrl] = useState("")
	const [instantVoiceUrl, setInstantVoiceUrl] = useState("")
	const [accountcode, setAccountcode] = useState("")
	const [apiKey, setApiKey] = useState("")

	const handleSave = () => {
		submit(sipUrl, instantVoiceUrl, accountcode, apiKey)
		setOpen(false)
	}

	const checkDisabled = () => {
		const allEmpty = !instantVoiceUrl && !instantVoiceUrl && !accountcode && !apiKey
		const allFilled = sipUrl && instantVoiceUrl && accountcode && apiKey
		return !(allEmpty || allFilled) 
	}

	return (
		<Dialog open={open} onClose={() => setOpen(false)}>
			<DialogTitle>Confirmação</DialogTitle>
			<DialogContent>
				<Alert severity="info" sx={{ marginBottom: "1rem" }}>
	        		Caso seu setup de voz esteja localizado no InstantVoice, preencha os campos abaixo.
	        		Caso contrário, deixe todos em branco.
	        	</Alert>
	        	<Box display="flex" flexDirection="column" gap={2}>
					<TextField
						size="small"
						label="URL SIP"
						fullWidth
						variant="outlined"
						value={sipUrl}
						onChange={(e) => setSipUrl(e.target.value)}
					/>
					<TextField
						size="small"
						label="URL InstantVoice"
						fullWidth
						variant="outlined"
						value={instantVoiceUrl}
						onChange={(e) => setInstantVoiceUrl(e.target.value)}
					/>
					<TextField
						size="small"
						label="Accountcode"
						fullWidth
						variant="outlined"
						value={accountcode}
						onChange={(e) => setAccountcode(e.target.value)}
					/>
					<TextField
						size="small"
						label="Chave de API"
						fullWidth
						variant="outlined"
						value={apiKey}
						onChange={(e) => setApiKey(e.target.value)}
					/>
				</Box>
			</DialogContent>
			<DialogActions>
				<Button onClick={() => setOpen(false)}>Cancelar</Button>
				<Button onClick={handleSave} disabled={checkDisabled()}>Salvar</Button>
			</DialogActions>
		</Dialog>
	)
}



const Channels = ({ enterprise }) => {

    const partnerId = 'DrXGjiPA';
    const user = getSession();

	const [loading, setLoading] = useState(false);
	const [waiting, setWaiting] = useState(false);
	const [numbers, setNumbers] = useState([]);
	const [reload, setReload] = useState(false)
	const [connectedPage, setConnectedPage]= useState(null)
	const [showWabaDialog, setShowWabaDialog] = useState(false)
	const [wabaId, setWabaId] = useState("")
	const [exibitionName, setExibitionName] = useState(null)
	const [enterpriseData, setEnterpriseData] = useState(null)
	const [enterpriseMore, setEnterpriseMore] = useState(null)
	const authRef = useRef({ code: null, userToken: null })
	const finishRef = useRef(null)
	const submittingRef = useRef(false)

	const [tab, setTab] = useState(0)

	const [showCallingUpdate, setShowCallingUpdate] = useState(false)

	const reloadState = () => {setTimeout(()=>setReload(p=>!p), 500)}

    const handleConnectCallback = (callbackObject) => {
        const clientId = callbackObject.client;
        const url = `api/enterprises/${enterprise.id}/360dialog_channels/`;

        callbackObject.channels.forEach((channel) => {
            api.post(url, { channel_id: channel }, { timeout: 0 })
            .then((res) => {
                if (res.status == 201) {
                    window.location.href = '/settings'
                    return;
                }
                if (res.status == 400) {
                    // TODO: callback is being executed twice, within
                    // 360dialog's window and again when it returns here
                    // this should be separated, otherwise it will throw
                    // a 400 BAD_REQUEST here
                    return;
                }
                throw res;
            })
            .catch((err) => {
                console.error(err);
            });
        });
    }

	const getNumbers = useCallback(async () => {
		setLoading(true)
	    try {
	        const [numbersRes, metaNumbersRes] = await Promise.all([
	            api.get(`api/enterprises/${enterprise.id}/360dialog_channels/`),
	            api.get(`api/enterprises/${enterprise.id}/whatsapp/?detail=true`)
	        ])

	        if (numbersRes.status !== 200 || metaNumbersRes.status !== 200) {
	            useNotification(
	                "Ops!",
	                "Não foi possível encontrar os números de WhatsApp.",
	                "danger"
	            )
	            return
	        }

	        const combinedNumbers = [...numbersRes.data, ...metaNumbersRes.data]
	        const wabaId = combinedNumbers.find(number => number.waba_id)
	        setNumbers(combinedNumbers)
			setWabaId(wabaId?.waba_id || null)
	    } catch (error) {
	        useNotification(
	            "Ops!",
	            "Ocorreu um erro ao buscar os números de WhatsApp.",
	            "danger"
	        )
	    } finally {
	        setLoading(false)
	    }
	}, [])

	useEffect(() => {
		getNumbers()
	}, [])

	useEffect(() => {
		const queryParams = new URLSearchParams(window.location.search);
		// Wait while API key is being generated
		setWaiting(queryParams.has('client') || queryParams.has('channels'))
	}, [])


	const facebookPlugin = useMemo(() => {
		return (<FacebookPlugin reloadState={reloadState} reload={reload} setConnectedPage={setConnectedPage} app="WHATSAPP"/>)
	}, [reload])

	const trySubmit = useCallback(() => {
		if (submittingRef.current) return

		const { code, userToken } = authRef.current
		const finishData = finishRef.current

		// Wait for all data
		if (!finishData || !code || !userToken) return

		submittingRef.current = true
		setLoading(true)

		const body = {
			...finishData,
			code,
			user_token: userToken,
		}

		api.post(`api/enterprises/${enterprise.id}/whatsapp/`, body, { timeout: 0 })
			.then((res) => {
				if (res.status === 200) getNumbers()
			})
			.finally(() => {
				setLoading(false)
				submittingRef.current = false
				// avoid resubmission
				finishRef.current = null
				authRef.current = { code: null, userToken: null }
			})
	}, [enterprise.id, getNumbers])

    useEffect(() => {
	    const handleMessage = (event) => {
	        if (! event.origin.endsWith("facebook.com")) 
	        	return

        	try {
	        	const data = JSON.parse(event.data)
	            if (data.type === "WA_EMBEDDED_SIGNUP" && data.event === "FINISH") {
	                finishRef.current = data.data
	                trySubmit()
	            }
	        } catch {}
	    }

	    window.addEventListener("message", handleMessage)
	    return () => {
	        window.removeEventListener("message", handleMessage)
	    }
	}, [])

	const launchWhatsAppSignup = () => {
	    FB.login(function (response) {
			if (response.authResponse) {
				authRef.current.code = response.authResponse.code ?? null
				authRef.current.userToken = connectedPage?.authResponse?.accessToken ?? null
				trySubmit()
			} else {
				console.log("User cancelled login or did not fully authorize.")
			}
		}, {
			config_id: process.env.REACT_APP_WHATSAPP_APP_CONFIG_ID ?? "788098360113528",
            response_type: "code",
            override_default_response_type: true,
            extras: {
                setup: {},
                featureType: "",
                sessionInfoVersion: 3
            }
		})
	}

	const syncWabaId = async (wabaId) => {
		setLoading(true)
		try {
			const response = await api.post(`api/enterprises/${enterprise.id}/whatsapp/sync_waba_id/`, { "waba_id": wabaId }, { timeout: 0 })
			if (response.status === 200) {
				window.location.reload()
				return
			}
			useNotification(
				"Ops!",
				"Falha ao sincronizar WABA ID, por favor tente novamente ou procure alguém do time de suporte.",
				"danger"
			)
		} catch (error) {
			console.error("Erro ao sincronizar WABA ID:", error)
			useNotification(
				"Ops!",
				error?.response?.data?.message || "Erro ao sincronizar WABA ID. Tente novamente.",
				"danger"
			)
		} finally {
			setLoading(false)
		}
	}

	const handleCallingChanges = (item) => {
		if (! item.whatsapp_calling) {
			setShowCallingActivate(item)
			return
		}
		setShowCallingDeactivate(item)
	}

	const updateCalling = async (item, status, sipUrl, instantVoiceUrl, accountcode, apiKey) => {
		setLoading(true)
		try {
			const response = await api.patch(`api/enterprises/${enterprise.id}/whatsapp/${item.id}/`, {
				"phone_id": item.phone_id,
				"phone_number": item.phone_number,
				"whatsapp_calling": status,
				"whatsapp_calling_url": sipUrl,
				"whatsapp_calling_instantvoice": instantVoiceUrl,
				"whatsapp_calling_accountcode": accountcode,
				"whatsapp_calling_api_key": apiKey
			}, { timeout: 0 })
			
			if (response.status === 200) {
				setShowCallingUpdate(false)
				setNumbers((prevState) =>
					prevState.map((number) =>
						number.id === item.id 
							? { ...number,
								whatsapp_calling: status,
								whatsapp_calling_url: (status !== "DISABLED") ? sipUrl : "",
								whatsapp_calling_instantvoice: (status !== "DISABLED") ? instantVoiceUrl : "",
								whatsapp_calling_accountcode: (status !== "DISABLED") ? accountcode : "",
								whatsapp_calling_api_key: (status !== "DISABLED") ? apiKey : ""
							} 
							: number
					)
				)
				useNotification(
					"Sucesso",
					"Status de voz alterado com sucesso.",
					"success"
				)
				return
			}
			useNotification(
				"Ops!",
				"Credenciais incorretas, por favor tente novamente ou procure alguém do time de suporte.",
				"danger"
			)
		} catch (error) {
			console.error("Erro ao atualizar WhatsApp calling:", error)
			useNotification(
				"Ops!",
				error?.response?.data?.message || "Erro ao atualizar status de voz. Tente novamente.",
				"danger"
			)
		} finally {
			setLoading(false)
		}
	}

	return (
        <Box className="input-settings settings-body">
        	<Loading loading={loading}/>
        	<Loading loading={! loading && waiting} message="Gerando chave de API..."/>

        	<Tabs
		        value={tab}
		        onChange={(event, newValue) => {
				    setTab(newValue);
				}}
		        sx={{
		            borderBottom: 1,
		            borderColor: 'divider',
		            marginBottom: 3
		        }}
		    >
		        <Tab label="Números" />
		        <Tab label="Consumo" />
		    </Tabs>

		    {tab === 0 && (
		        <>
		            <Alert className="telegram-info" severity="info">
						<AlertTitle className="push-bottom">
							Para incluir uma conta WhatsApp no kwik, conectada diretamente com a Meta, é necessário:
						</AlertTitle>
						<Box>
							<p>Uma conta empresarial no facebook.</p>
							<p>Ceder permissões ao Kwik, clicando no botão abaixo: {facebookPlugin}</p>
						</Box>
						<Box className="push-s-top">
							Você pode adicionar seu número clicando em um dos botão abaixo.
						</Box>
					</Alert>
		        	{numbers.length !== 0 &&
		        		<>
				        	<Box className="category-title push-bottom push-top">Números</Box>
				            <Box display="flex" flexDirection="column" gap={2}>
			            		{numbers.map((item, index) => (
					            	<Box display="flex" gap={2} alignItems="center">
										<Box>
											<Tooltip title='Nome de exibição'><IconButton onClick={()=>setExibitionName(item)}><DriveFileRenameOutlineIcon /></IconButton></Tooltip>
											<Tooltip title='Informações da empresa'><IconButton onClick={()=>setEnterpriseData(item)}><BadgeIcon /></IconButton></Tooltip>
											{/* <Tooltip title='Informações adicionais do número'><IconButton onClick={()=>setEnterpriseMore(item)}><InfoIcon /></IconButton></Tooltip> */}
										</Box>
					            		<Box>{item.phone_number}</Box>
					            		<Box>{item.phone_name}</Box>
					            		{"info" in item &&
										<>
											<Box className='align-whatsapp-main-table'>
						            			<Box>Status:</Box>
					            				<Box>
					            					{translate[item.info.status]}
						            			</Box>
					            			</Box>
					            			<Box className='align-whatsapp-main-table'>
						            			<Box>Qualidade:</Box>
					            				<Box>
					            					<CircleIcon 
					            						sx={{color: item.info.quality_rating}}
					            					/>
						            			</Box>
					            			</Box>
										</>
					            		}
					            		{enterprise.whatsapp_calling &&
					            			<>
						            			<Box>Voz:</Box>
						            			<Box>
						            				<FormControl fullWidth size="small">
														<InputLabel>Status</InputLabel>
							            				<Select
							            					size="small"
															value={item.whatsapp_calling}
															label="Status"
															onChange={(event) => setShowCallingUpdate([
																item,
																event.target.value,
																item.whatsapp_calling_url,
																item.whatsapp_calling_instantvoice,
																item.whatsapp_calling_accountcode,
																item.whatsapp_calling_api_key
															])}
														>
															<MenuItem value="ENABLED">
																Ativado
															</MenuItem>
															{/*<MenuItem value="OUTBOUND">
																Somente Sainte
															</MenuItem>*/}
															<MenuItem value="DISABLED">
																Desativado
															</MenuItem>
														</Select>
													</FormControl>
							            		</Box>
							            		{item.whatsapp_calling && item.whatsapp_calling_url &&
							            			<Tooltip
														title={
															<div>
																SIP: {item.whatsapp_calling_url}<br />
																InstantVoice: {item.whatsapp_calling_instantvoice}<br />
																accountcode: {item.whatsapp_calling_accountcode}<br />
																chave: {item.whatsapp_calling_api_key}
															</div>
														}
														arrow
													>
														<IconButton>
															<HelpIcon />
														</IconButton>
													</Tooltip>
							            		}
							            	</>
					            		}
					            	</Box>
					            ))}
					        </Box>
					        {! enterprise.whatsapp_calling &&
						        <Box sx={{ width: "41rem", marginTop: '1rem' }}>
							        <Alert severity="warning">
						        		Kwik WhatsApp Calling disponível, entre em contato com seu gerente de contas para ativar.
						        	</Alert>
						        </Box>
			        		}
				        </>
		        	}
		        	{numbers.length < enterprise.max_numbers &&
		        		<Box style={{ marginTop: "1rem" }}>
		        			{enterprise.abstraction_layer &&
		        				<Box sx={{ display: "flex", gap: ".5rem" }}>
				        			<LoadingButton 
					    				startIcon={<AddIcon />} 
						        		variant="contained"
						        		onClick={() => launchWhatsAppSignup()}
						        	>
						        		Adicionar
						        	</LoadingButton>
						        	{getSession().username.endsWith("@instant.com.br") &&
							        	<LoadingButton sx={{ backgroundColor: "green", "&:hover": { backgroundColor: "#006400" }}}
							        		startIcon={<AddIcon />}
							        		variant="contained"
							        		onClick={() => setShowWabaDialog(true)}
						        		>
						        			Sincronizar Waba ID
							        	</LoadingButton>
						        	}
						        </Box>
		        			}
		        			{! enterprise.abstraction_layer &&
					        	<ConnectButton partnerId={partnerId}
					                callback={handleConnectCallback}
					                queryParameters={{
					                    email        : user.username,
					                    name         : `${user.first_name} ${user.last_name}`,
					                    redirect_url : window.location.href
					                }}
					                className="onboarding-connect-button"
					                label={(<><AddIcon /> Adicionar</>)}
					            />
					        }
				        </Box>
		        	}
		        	{numbers.length >= enterprise.max_numbers &&
		        		<Box className="whatsapp-mumbers-info">
				        	<LoadingButton startIcon={<AddIcon />} 
				        		variant="contained" 
				        		disabled={true}
				        	>Adicionar</LoadingButton>
				        	<Alert severity="info">
				        		Entre em contato com seu gerente de contas para contratar mais uma linha. Caso já tenha adquirido a linha, fale com nosso suporte para liberação.
				        	</Alert>
				        </Box>
		        	}
		        	{showWabaDialog &&
		        		<Dialog open={showWabaDialog} onClose={() => setShowWabaDialog(false)}>
							<DialogTitle>Sincronizar WhatsApp Business Account ID</DialogTitle>
							<Divider />
							<DialogContent>
								<TextField
									size="small"
									label="WABA ID"
									fullWidth
									value={wabaId}
									onChange={(e) => setWabaId(e.target.value)}
								/>
							</DialogContent>
							<DialogActions>
								<Button onClick={() => setShowWabaDialog(false)}>Cancel</Button>
								<Button onClick={() => syncWabaId(wabaId)} disabled={! wabaId}>Adicionar</Button>
							</DialogActions>
						</Dialog>
		        	}
		        	{showCallingUpdate && showCallingUpdate[1] == "ENABLED" &&
		        		<WhatsAppCallingDialog
		        			open={showCallingUpdate}
			                setOpen={setShowCallingUpdate}
			                submit={(sipUrl, instantVoiceUrl, accountcode, apiKey) => updateCalling(
			                	showCallingUpdate[0],
			                	showCallingUpdate[1],
			                	sipUrl,
			                	instantVoiceUrl,
			                	accountcode,
			                	apiKey
			                )}
			            />
		        	}
		        	{showCallingUpdate && showCallingUpdate[1] == "DISABLED" &&
		        		<ConfirmationDialog open={showCallingUpdate}
							title="Confirmação"
							description="Tem certeza que deseja desativar chamadas de voz WhatsApp?"
							handleClose={() => setShowCallingUpdate(false)}
							handleSubmit={() => updateCalling(
								showCallingUpdate[0],
								showCallingUpdate[1],
								showCallingUpdate[2],
								showCallingUpdate[3],
								showCallingUpdate[4],
								showCallingUpdate[5]
							)}
						/>
		        	}
					{exibitionName && <ExibitionNameModal data={exibitionName} handleClose={(data)=>{
						const number = numbers.find(number => number.id === data.item_id)
						if (number)
							number.info = data;
						setExibitionName(null); }} />}
					{enterpriseData && <EnterpriseDataModal data={enterpriseData} handleClose={()=>{setEnterpriseData(null)}}/>}
					{enterpriseMore && <EnterpriseMoreModal data={enterpriseMore} handleClose={()=>{setEnterpriseMore(null)}}/>}
		        </>
		    )}

		    {tab === 1 && (
		        <>
		            <UsageComponent enterpriseId={enterprise?.id} wabaId={wabaId} />
		        </>
		    )}
        </Box>
	)
}

export default Channels
